"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Types = _interopRequireDefault(require("../../types/Types"));

var _ActionCreators = _interopRequireDefault(require("../../change/ActionCreators"));

var _default = function _default(_this) {
  return {
    insertAfterSelf: function insertAfterSelf(value) {
      _this.dispatch(_ActionCreators.default.insertAfterSelf(value));
    },
    insertBeforeSelf: function insertBeforeSelf(value) {
      _this.dispatch(_ActionCreators.default.insertBeforeSelf(value));
    },
    moveSelf: function moveSelf(key) {
      (0, _Types.default)("moveSelf()", "key", "keyIndex")(key);

      _this.dispatch(_ActionCreators.default.moveSelf(key));
    },
    swapNextSelf: function swapNextSelf() {
      _this.dispatch(_ActionCreators.default.swapNextSelf());
    },
    swapPrevSelf: function swapPrevSelf() {
      _this.dispatch(_ActionCreators.default.swapPrevSelf());
    },
    swapSelf: function swapSelf(key) {
      (0, _Types.default)("swapSelf()", "key", "keyIndex")(key);

      _this.dispatch(_ActionCreators.default.swapSelf(key));
    }
  };
};

exports.default = _default;